import { useParams } from "react-router";
import { FrameworkPage } from "../specification/FrameworkPage";
import { StagePage } from "../layout/StagePage";
import { stageHeadingLabel } from "../stage-vocabulary";

/** Stage 5: Specification, where the attorney plans and confirms the Detailed Description. Zero props by contract. */
export function PlanningOutlineStagePane() {
  const { taskId } = useParams<{ taskId: string }>();
  return (
    <StagePage
      guide="specification"
      testId="specification-pane"
      taskId={taskId}
      eyebrow={`${stageHeadingLabel("planning-outline")} · Specification`}
      title="Plan the Detailed Description"
      lede={
        <>
          Read from the thesis, the claim strategy and everything captured in{" "}
          <strong>Figures</strong>, this is how the{" "}
          <strong>Detailed Description</strong> should be approached. Adjust the
          plan before drafting.
        </>
      }
    >
      {taskId !== undefined && <FrameworkPage taskId={taskId} />}
    </StagePage>
  );
}
